import { render } from "./MapDraggableInGame.vue?vue&type=template&id=6ffdf040&scoped=true"
import script from "./MapDraggableInGame.vue?vue&type=script&lang=js"
export * from "./MapDraggableInGame.vue?vue&type=script&lang=js"

import "./MapDraggableInGame.vue?vue&type=style&index=0&id=6ffdf040&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffdf040"]])

export default __exports__